import { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    InputAdornment,
    IconButton,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Notification from '../../../../util/notifications/Notification';

// Login-Formular (Karte mit E-Mail/Passwort und Aktionen).
function LoginForm({ loading, message, onNotificationClose, onSubmit, onForgot, onRegister }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(email, password);
    };

    return (
        <Paper
            elevation={3}
            sx={{
                p: { xs: 3, sm: 4 },
                width: '100%',
                maxWidth: 450,
            }}
        >
            <Box display="flex" justifyContent="center" mb={3}>
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LockIcon sx={{ fontSize: 32, color: 'white' }} />
                </Box>
            </Box>

            <Typography variant="h5" align="center" gutterBottom fontWeight={700}>
                Willkommen zurück
            </Typography>
            <Typography variant="body2" align="center" color="text.secondary" mb={3}>
                Melde dich an um fortzufahren
            </Typography>

            {(message.status === "error" || message.status === "success") && (
                <Notification
                    type={message.type}
                    message={message.text}
                    onClose={onNotificationClose}
                />
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                    label="E-Mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                    fullWidth
                    required
                    disabled={loading}
                    autoComplete="email"
                    inputProps={{ maxLength: 50 }}
                />
                <TextField
                    label="Passwort"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    variant="outlined"
                    fullWidth
                    required
                    disabled={loading}
                    autoComplete="current-password"
                    InputProps={{
                        maxLength: 50,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    fullWidth
                    disabled={loading}
                    sx={{ py: 1.5, mt: 1 }}
                >
                    {loading ? 'Einloggen...' : 'Einloggen'}
                </Button>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', mt: 1 }}>
                    <Button
                        variant="text"
                        onClick={onForgot}
                        fullWidth
                        disabled={loading}
                        size="small"
                    >
                        Passwort vergessen?
                    </Button>
                    <Button
                        variant="text"
                        onClick={onRegister}
                        fullWidth
                        disabled={loading}
                        size="small"
                    >
                        Registrieren
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
}

export default LoginForm;
